import { render } from "./new_form.vue?vue&type=template&id=ecb150f4"
import script from "./new_form.vue?vue&type=script&lang=js"
export * from "./new_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__